import { ICprSnapshotProps } from "../types";

export function getInvalidParameters(io: ICprSnapshotProps): string[] {
  const invalidFields = [];
  if (!io.filters.finalDate && !io.filters.initialDate) {
    invalidFields.push("initial date or final date");
  }
  if (
    !io.filters.bdrCommercialId &&
    !io.filters.clienthist_corigrpcountryaxis &&
    !io.filters.clienthist_corigrpsegment &&
    !io.filters.clienthist_grpsegment &&
    !io.filters.clienthist_lesegment
  ) {
    invalidFields.push("client or segmentation / country axis");
  }
  if (!io.filters.photoEnd) {
    invalidFields.push("final snapshot");
  }
  if (!io.filters.photoStart) {
    invalidFields.push("initial snapshot");
  }
  return invalidFields;
}
